module.exports = __webpack_public_path__ + "img/icon-33.098eb2cf.png";